export const categoryInfos = [
  {
    title: "Electronics",
    name: "electronics",
    imageLink: "https://m.media-amazon.com/images/I/71sfGvhRPCL._AC_UY218_.jpg",
  },
  {
    title: "Discover fashion trends",
    name: "women's clothing",
    imageLink: "https://m.media-amazon.com/images/I/41psry4C0jL._AC_SY550_.jpg",
  },

  {
    title: "Men's clothing",
    name: "men's clothing",
    imageLink: "https://m.media-amazon.com/images/I/81l5ZD2Gg8L._AC_SX522_.jpg",
  },
  {
    title: "Jewelery",
    name: "jewelery",
    imageLink: "https://m.media-amazon.com/images/I/41p46DN6C3L._AC_UL320_.jpg",
  },
];
